import React, { Component } from 'react';

import { FatalAttraction, GoogleTagManager as GTM } from '@vpr/tracking';

import { Plus } from '@vimeo/bokeh-icons';
import { translate } from '@vimeo/i18n-runtime';
import { Badge, Button } from '@vimeo/iris/components';
import { HamburgerMenu } from '@vimeo/iris/icons';
import { Menu } from '@vimeo/iris/layout';

import AuthModal from 'src/_components/AuthModal';
import IMAGES from 'src/_images/images.json';
import { createAppCheck } from 'src/_tools/helpers';

import styles from './Navigations.module.scss';
import SideMenuNavigation from './SideMenuNavigation';

class TopNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showUserProfile: false,
      showLoginModal: false,
      sideMenu: false,
    };
    this.toggleLoginModal = this.toggleLoginModal.bind(this);
  }

  toggleLoginModal() {
    this.setState({ showLoginModal: !this.state.showLoginModal });
  }

  setLastPageCookie() {
    document.cookie = `last_page=${window.location.href};domain=.${devsite?.vimeo_url.replace(
      'https://',
      '',
    )};path=/`;
  }

  render() {
    const { showUserProfile, showLoginModal, sideMenu } = this.state;
    const { backgroundColor } = this.props;

    let ProfileMenu = devsite?.user && (
      <Menu className={styles.profileMenu}>
        <div className={styles.user_avatar}>
          {devsite.user.name}
          {devsite?.user.badge.type && (
            <Badge
              key={devsite.user.name}
              format={devsite.user.badge.type}
              className={styles.user_badge}
            >
              {devsite.user.badge.text}
            </Badge>
          )}
        </div>
        <Menu.Item href={devsite.user.url}>Me</Menu.Item>
        <Menu.Item href={'/apps'}>API Apps</Menu.Item>
        <Menu.Item href={'/help'}>Help</Menu.Item>
        <form method="post" action={`${devsite?.vimeo_url}/log_out`}>
          <input type="hidden" name="token" value={devsite?.xsrft} />
          <Menu.Item type="submit" onClick={() => this.setLastPageCookie()}>
            Log out
          </Menu.Item>
        </form>
      </Menu>
    );

    let LoggedOutMenu = (
      <Menu>
        <Menu.Item>
          <a href={`${devsite?.vimeo_url}/join?redirect=${window.location.href}`}>Join</a>
        </Menu.Item>
        <Menu.Item>
          <a href={`${devsite?.vimeo_url}/log_in?redirect=${window.location.href}`}>Log In </a>
        </Menu.Item>
      </Menu>
    );

    let MobileSideMenu = ({ className }) => (
      <div className={className}>
        <SideMenuNavigation page="top-nav" />
        {devsite?.user ? ProfileMenu : LoggedOutMenu}
      </div>
    );

    return (
      <div className={styles.topnav} style={{ backgroundColor: backgroundColor || '#f6f7f8' }}>
        <span className={styles.color_ribbon}></span>
        <div className={styles.topnav_wrapper}>
          <a href={'/'}>
            <img src={IMAGES.DARKLOGO} alt="vimeo logo" width="84px" height="24px" />
            <span className={styles.logo_extra}>developer( );</span>
          </a>

          <div className={styles.topnav_menu}>
            <nav className={styles.topnav_menu_items}>
              {!devsite?.user && (
                <>
                  <a
                    href={`${devsite?.vimeo_url}/join?redirect=${window.location.href}`}
                    onClick={() => {
                      FatalAttraction.trackClick({
                        container: 'top_nav',
                        component: 'join',
                        target: '/join',
                        ref_path: window.location.pathname,
                      });
                      GTM.trackEvent('top_nav_join_click', {
                        event: 'top_nav_join_click',
                        category: 'top_nav',
                        action: 'join',
                      });
                    }}
                  >
                    {translate('Join')}
                  </a>
                  <AuthModal type="login" active={showLoginModal} dismiss={this.toggleLoginModal}>
                    <a
                      onClick={() => {
                        this.toggleLoginModal();
                        FatalAttraction.trackClick({
                          container: 'top_nav',
                          component: 'login',
                          target: '/log_in',
                          ref_path: window.location.pathname,
                        });
                        GTM.trackEvent('top_nav_login_click', {
                          event: 'top_nav_login_click',
                          category: 'top_nav',
                          action: 'login',
                        });
                      }}
                    >
                      {translate('Log In')}
                    </a>
                  </AuthModal>
                </>
              )}
              <a href={'/api/guides/start'}>{translate('The API')}</a>
              <a href={'/player/sdk'}>{translate('The Player')}</a>
              <a href={'/api/mcp-server'}>{translate('The MCP Server')}</a>
              <a href="https://medium.com/vimeo-engineering-blog" target="_blank" rel="noreferrer">
                {translate('Blog')}
              </a>
              <a
                href="http://vimeo.com/enterprise/contact-us/dev?mkc=113073"
                target="_blank"
                rel="noreferrer"
              >
                {translate('Contact Sales')}
              </a>
            </nav>
          </div>
          <div className={styles.right_menu}>
            {devsite?.user && (
              <a
                className={styles.avatar}
                href="#"
                onClick={() => {
                  this.setState({ showUserProfile: !showUserProfile });
                }}
              >
                <img className={styles.avatar_img} alt="User Avatar" src={devsite.user.avatar} />
              </a>
            )}
            <div>
              <Button onClick={(e) => createAppCheck('topnav', e, this)} size="sm" icon={<Plus />}>
                {translate('Create an app')}
              </Button>
            </div>
          </div>
        </div>
        {showUserProfile && <div className={styles.userprofile_desktop}> {ProfileMenu}</div>}
        <div id="mobile-top-nav" className={styles.mobile_wrapper}>
          <HamburgerMenu
            className={styles.menu_icon}
            onClick={() =>
              this.setState({
                sideMenu: !sideMenu,
              })
            }
          />
          <a href={'/'}>
            <img src={IMAGES.MINIBLUELOGO} alt="mini vimeo log" width="24px" height="24px" />
            <span className={styles.logo_extra_mobile}>dev( );</span>
          </a>
        </div>
        {sideMenu && <MobileSideMenu className={styles.mobile_nav_panel} />}
      </div>
    );
  }
}

export default TopNavigation;
